/* {% We want to use JavaScript only, because if it fails, customer can still checkout */
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    // Constants
    const primaryCheckoutButton = {
      selector: 'div.cart__footer__checkout__buttons button[name="checkout"]',
      class: 'button--primary'
    }

    // Helper Functions
    function disableCheckoutButton(obj) {
      const button = document.querySelector(obj.selector);
      if (!button) return;

      button.classList.remove(obj.class);
      button.classList.add('button--disabled');
      button.disabled = true;
      button.style.setProperty('pointer-events', 'none', 'important');
    }

    function enableCheckoutButton(obj) {
      const button = document.querySelector(obj.selector);
      if (!button) return;

      button.classList.add(obj.class);
      button.classList.remove('button--disabled');
      button.disabled = false;
      button.style.setProperty('pointer-events', 'all', 'important');
    }

    function enableAllCheckoutButtons() {
      enableCheckoutButton(primaryCheckoutButton);
    }

    function disableAllCheckoutButtons() {
      disableCheckoutButton(primaryCheckoutButton);
    }

    // Handler
    function handleChange(event) {
      const isChecked = event.target.checked;
      if (isChecked) {
        enableAllCheckoutButtons();
      } else {
        disableAllCheckoutButtons();
      }
    }

    function resetCheckbox() {
      // Hack to handle delay in rendering
      setTimeout(function() {
        const checkbox = document.querySelector('input[name="checkout-agree-terms"]');
        checkbox.checked = false;
      }, 500);
    }

    // Main
    function init() {
      // Add event listener
      const input = document.querySelector('div.cart__footer__checkout__terms input[name="checkout-agree-terms"]');
      // Disable checkout buttons on load
      if (input) {
        input.addEventListener('change', handleChange);
        disableAllCheckoutButtons();
        resetCheckbox();
        input.removeAttribute('disabled');

      // Reset checkbox
      } else {
        console.warn('Terms checkbox not found – checkout gating skipped.');
      }
    }

    init();
  });
})();
